import API from "./API"

const endpoint = "crop-designer-settings"

export const updateCropDesignerSettingCrop = (settingId, nextCropId) =>
  API.put(`/${endpoint}/${settingId}/`, { next_crop: nextCropId })

export const updateCropDesignerSettingTargetYield = (settingId, targetYields) =>
  API.put(`/${endpoint}/${settingId}/`, { target_yields: targetYields })
